// extracted by mini-css-extract-plugin
export default {"promocodes":"PromoCodes_promocodes__m5xIN","header":"PromoCodes_header__M1Efr","title":"PromoCodes_title__35UXC"};